import { createAction, props } from '@ngrx/store';

export const userAll = createAction('USER_ALL', props<{items: any}>());
export const userList = createAction('USER_LIST', props<{items: any}>());
export const userCreate = createAction('USER_CREATE', props<{item: any}>());
export const userUpdate = createAction('USER_UPDATE', props<{item: any}>());
export const userDelete = createAction('USER_DELETE', props<{item: any}>());
